import { httpClient3, httpClient } from './';

export const _queryEventsByMachineId = ({
  machine_id,
  event_id,
  time_range
}) => {
  return httpClient3
    .post(`events/query`, {
      machine_id,
      event_id,
      time_range
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAllEvents = () => {
  return httpClient3.get(`/events/queryEventMap`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
// export const createEventToMachine = ({ machine_id, event_id, time_range }) => {
//   return httpClient3.post(`events/query`,
//     {
//       machine_id,
//       event_id,
//       time_range
//     }).then(res => {
//     if (res.data.state_code === 0) {
//       return Promise.resolve(res.data.data);
//     } else {
//       return Promise.reject(new Error(`${res.data.erro_msg}`));
//     }
//   });
// };
export const _newestTs = machine_ids => {
  return httpClient3
    .post(`/events/queryEvent/newest_ts`, { machine_ids }, {})
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getManualPersant = (machine_list) => {
  return httpClient.post(`order/manual_rate/query`,
    {machine_list}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
